import { render, staticRenderFns } from "./CadastroFuncao.vue?vue&type=template&id=4ce846ae&"
import script from "./CadastroFuncao.vue?vue&type=script&lang=js&"
export * from "./CadastroFuncao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports